import React, { Component } from 'react';
import ScrollButton from './ScrollButton.js';
import Sticky from './Sticky.js';

class Scrollupcontainer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="scrollupContainer" id= "scroll-upContainer" >
      <div className="long">
      <Sticky className="sticky" enter="290" exit = "0" children ={ScrollButton} >
        <ScrollButton scrollStepInPx="50" delayInMs="8.66" />
      </Sticky>
      </div>
      </div>
    );
  }
}

export default Scrollupcontainer;
